import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=dba3b98e&scoped=true&"
import script from "./SignDocument.vue?vue&type=script&lang=js&"
export * from "./SignDocument.vue?vue&type=script&lang=js&"
import style0 from "./SignDocument.vue?vue&type=style&index=0&id=dba3b98e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba3b98e",
  null
  
)

export default component.exports